import styled from 'styled-components';

import { Loader } from 'shared/components/Loader';
import { CollectionItem } from 'productTemplate/components/windows/CollectionItem';
import { variableFontRegular } from 'styles/theme';

interface IWindowItemFeaturedInProps {
  collectionSlugs: string[];
  isLoading: boolean;
  title: string;
}

export const WindowItemFeaturedIn = ({
  collectionSlugs,
  isLoading,
  title,
}: IWindowItemFeaturedInProps) => {
  if (isLoading) {
    return (
      <WindowItemFeaturedIn.Container>
        <Loader />
      </WindowItemFeaturedIn.Container>
    );
  }

  if (collectionSlugs.length === 0) {
    return null;
  }

  return (
    <WindowItemFeaturedIn.Wrapper>
      <WindowItemFeaturedIn.Title data-qa={`${title}_condition`.toLowerCase().replace(/ /g, '_')}>
        {title}
      </WindowItemFeaturedIn.Title>
      <WindowItemFeaturedIn.Collections>
        {collectionSlugs.map((slug) => (
          <CollectionItem key={slug} slug={slug} />
        ))}
      </WindowItemFeaturedIn.Collections>
    </WindowItemFeaturedIn.Wrapper>
  );
};

WindowItemFeaturedIn.Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 68px;
  padding: 16px;
`;

WindowItemFeaturedIn.Wrapper = styled.div`
  align-items: flex-start;
  border-bottom: ${({ theme }) => theme.borders.black};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
  text-transform: capitalize;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    padding: 16px 16px 40px 16px;
  }
`;

WindowItemFeaturedIn.Title = styled.span`
  width: 50%;

  ${variableFontRegular({ height: '14px', size: '9.5px' })}
`;

WindowItemFeaturedIn.Collections = styled.div`
  text-align: right;
  > a {
    display: block;
  }
  > a:not(:last-child) {
    margin-bottom: 8px;
  }
  a:hover {
    text-decoration: underline;
  }
`;
